document.addEventListener('quickadd:loaded', event => {
  const quick_add_modal = document.querySelector('#QuickAddHolder')
  const product_element = document.querySelector('section[id^="MainProduct-"]')
  
  preventVariantURLSwitching(quick_add_modal)
  preventDuplicatedIDs(product_element)

  if (window.Shopify && Shopify.PaymentButton) {
    Shopify.PaymentButton.init();
  }

  if (window.ProductModel) window.ProductModel.loadShopifyXR();

  removeDOMElements(product_element)

  const quickForm = quick_add_modal.querySelector('form[data-type="add-to-cart-form"]')
  quickForm.addEventListener('submit', quickAddSubmit)
})

function preventVariantURLSwitching(el) {
  const variantPicker = el.querySelector('variant-radios,variant-selects');
  if (!variantPicker) return;

  variantPicker.setAttribute('data-update-url', 'false');
}

function preventDuplicatedIDs(el) {
  const sectionId = el.dataset.section;
  el.innerHTML = el.innerHTML.replaceAll(sectionId, `quickadd-${sectionId}`);
  el.querySelectorAll('variant-selects, variant-radios, product-info').forEach((element) => {
    element.dataset.originalSection = sectionId;
  });
}

function removeDOMElements(el) {
  const pickupAvailability = el.querySelector('pickup-availability');
  if (pickupAvailability) pickupAvailability.remove();

  const productModal = el.querySelector('product-modal');
  if (productModal) productModal.remove();

  const modalDialog = el.querySelectorAll('modal-dialog');
  if (modalDialog) modalDialog.forEach((modal) => modal.remove());
}

function quickAddSubmit(evt, callback) {
  evt.preventDefault();

  const atcButton = document.querySelector('#QuickAddHolder .add-to-cart')
  const quickForm = document.querySelector('#QuickAddHolder form[data-type="add-to-cart-form"]')
  
  if (status.loading) {
    return;
  }
  
  // Loading indicator on add to cart button
  atcButton.classList.add("btn--loading");
  
  status.loading = true;
  
  var data = theme.utils.serialize(quickForm);
  
  fetch(theme.routes.cartAdd, {
    method: "POST",
    body: data,
    credentials: "same-origin",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    },
  })
    .then((response) => response.json())
    .then(
      function (data) {
        if (data.status === 422) {
        } else {
          var product = data;
          var errors = quickForm.querySelector(".errors");
          if (errors) {
            errors.remove();
          }
  
          document.dispatchEvent(
            new CustomEvent("ajaxProduct:added", {
              detail: {
                product: product,
                addToCartBtn: atcButton,
              },
            })
          );
  
          // add dataLayer to tag manager in product page
          // window.dataLayer.push({ event: "FlashyCart" });
          new FlashyProductRecommendations(
            22461,
            "cart-recomendations",
            "הולך מצויין עם"
          ).init();
        }
  
        status.loading = false;
        atcButton.classList.remove("btn--loading");
  
        // Reload page if adding product from a section on the cart page
        if (document.body.classList.contains("template-cart")) {
          window.scrollTo(0, 0);
          location.reload();
        }
      }
    ); 
}

document.addEventListener('CartDrawer:open', () => {
  new FlashyProductRecommendations(
    22461,
    "cart-recomendations",
    "הולך מצויין עם"
  ).init();
})

$(document).ready(function() {
  $('.hotspot__button').on('click', function() {
    let screenWidth = $(window).width();
    let position = $(this).position()
    
    if (screenWidth > 750) {
      $('.hotspots__content').css('left', ((parseInt(position.left) + 100) + 'px'))
      $('.hotspots__content').css('top', ((parseInt(position.top) - 30) + 'px'))
    } else {
      $('.hotspots__content').css('left', 0)
      $('.hotspots__content').css('bottom', '15px')
      $('.hotspots__content').css('top', 'auto')
      $('.hotspots__content').css('right', 0)
    }

    $('.hotspots__content').css('z-index', 1)
    $('.hotspots__content').css('opacity', 1)

  })

  $('.close_hotspot').on('click', function() {
    $('.hotspots__content').css('opacity', 0)
    $('.hotspots__content').css('z-index', -1)
  })
});


$(document).ready(function() {
  $('.bundle-variant-picker input[name*="Color"]').on('change', function() {
    const bundle_index = $(this).parent().attr('data-gallery-index')
    const this_variant = $(this).val().replaceAll(' ','-')
    const this_variant_media = $(('.bundle-media-item[data-variant="' + this_variant + '"]'))

    $(('.gallery-' + bundle_index + ' .bundle-media-item')).removeClass('is-active')
    this_variant_media.addClass('is-active')
  })

  $('.bundle-variant-picker input[name*="color"]').on('change', function() {
    const bundle_index = $(this).parent().attr('data-gallery-index')
    const this_variant = $(this).val().replaceAll(' ','-')
    const this_variant_media = $(('.bundle-media-item[data-variant="' + this_variant + '"]'))

    $(('.gallery-' + bundle_index + ' .bundle-media-item')).removeClass('is-active')
    this_variant_media.addClass('is-active')
  })
})

function searchndiseQuickAdd(event) {
  
}